var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({class:("icon " + _vm.size),style:({
    'mask-image': ("url(" + _vm.iconUrl + ")"),
    'mask-repeat': 'no-repeat',
    'mask-position': 'center',
    'mask-size': 'contain',
    display: 'inline-block'
  }),on:{"click":function($event){return _vm.$emit('click')}}},'div',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }